import axios from '../../../../shared/axios';

import originAxios from 'axios';

import { AppDispatch } from '../../../../store';

import * as actionTypes from '../constants/smses';

import { errorText } from '../../../../shared/constants/errorText';

import {
  CheckPhoneNumberResult,
  GetUpdatesResult,
  InsuredPhoneNumbersCollection,
  InsuredPhonesCollection,
  MessageControlParameters,
  MessagesCollection,
  SMSe,
  SmsMigrationData,
  SmsChat,
  GetMessagesRequest,
  GetInsuredsPhonesRequest,
  SendMessageRequest,
  GetAllInsuredNumbersRequest,
  SmsGetUpdatesRequest,
  SendMassMessagesRequest,
  CheckPhoneNumberRequest,
  SaveMigrationRequest,
} from '../../models';

const getMessagesStart = () => {
  return {
    type: actionTypes.SMSES_GET_MESSAGES_START,
  };
};

const getMessagesSuccess = (data: MessagesCollection) => {
  return {
    type: actionTypes.SMSES_GET_MESSAGES_SUCCESS,
    data,
  };
};

const getMessagesFail = (error: any) => {
  return {
    type: actionTypes.SMSES_GET_MESSAGES_FAIL,
    error,
  };
};

let getMessagesCancel: (message: string) => void;

export const getMessages = (params: GetMessagesRequest) => {
  return (dispatch: AppDispatch) => {
    return new Promise<MessagesCollection>((resolve, reject) => {
      dispatch(getMessagesStart());
      const url = `/sms/get-messages`;

      if (typeof getMessagesCancel == 'function') {
        getMessagesCancel(errorText.canceledByFetchingNewData);
      }

      axios
        .get(url, {
          params,
          cancelToken: new originAxios.CancelToken((cancel) => {
            getMessagesCancel = cancel;
          }),
        })
        .then((response) => {
          dispatch(getMessagesSuccess(response.data));
          resolve(response.data);
        })
        .catch((err) => {
          if (originAxios.isCancel(err) && err.message === errorText.canceledByFetchingNewData) {
            resolve({} as MessagesCollection);
          } else {
            dispatch(getMessagesFail(err));
            reject(err);
          }
        });
    });
  };
};

export const setMessages = (data: MessagesCollection) => {
  return {
    type: actionTypes.SMSES_SET_MESSAGES,
    data,
  };
};

const getInsuredsPhonesStart = () => {
  return {
    type: actionTypes.SMSES_GET_INSUREDS_PHONES_START,
  };
};

const getInsuredsPhonesSuccess = (data: InsuredPhonesCollection) => {
  return {
    type: actionTypes.SMSES_GET_INSUREDS_PHONES_SUCCESS,
    data,
  };
};

const getInsuredsPhonesFail = (error: any) => {
  return {
    type: actionTypes.SMSES_GET_INSUREDS_PHONES_FAIL,
    error,
  };
};

export const getInsuredsPhones = (params: GetInsuredsPhonesRequest) => {
  return (dispatch: AppDispatch) => {
    return new Promise<InsuredPhonesCollection>((resolve, reject) => {
      dispatch(getInsuredsPhonesStart());

      const url = `/sms/get-insureds-phones`;

      axios
        .get(url, { params })
        .then((response) => {
          dispatch(getInsuredsPhonesSuccess(response.data));
          resolve(response.data);
        })
        .catch((err) => {
          dispatch(getInsuredsPhonesFail(err));
          reject(err);
        });
    });
  };
};

const sendMessageStart = () => {
  return {
    type: actionTypes.SMSES_SEND_MESSAGE_START,
  };
};

const sendMessageSuccess = (data: SMSe) => {
  return {
    type: actionTypes.SMSES_SEND_MESSAGE_SUCCESS,
    data,
  };
};

const sendMessageFail = (error: any) => {
  return {
    type: actionTypes.SMSES_SEND_MESSAGE_FAIL,
    error,
  };
};

export const sendMessage = (params: SendMessageRequest) => {
  return (dispatch: AppDispatch) => {
    return new Promise<SMSe>((resolve, reject) => {
      dispatch(sendMessageStart());

      const url = `/sms/send-message`;

      axios
        .post(url, params)
        .then((response) => {
          dispatch(sendMessageSuccess(response.data));
          resolve(response.data);
        })
        .catch((err) => {
          dispatch(sendMessageFail(err));
          reject(err);
        });
    });
  };
};

const getMessageControlParametersStart = () => {
  return {
    type: actionTypes.SMSES_GET_MESSAGE_CONTROL_PARAMETERS_START,
  };
};

const getMessageControlParametersSuccess = (data: MessageControlParameters) => {
  return {
    type: actionTypes.SMSES_GET_MESSAGE_CONTROL_PARAMETERS_SUCCESS,
    data,
  };
};

const getMessageControlParametersFail = (error: any) => {
  return {
    type: actionTypes.SMSES_GET_MESSAGE_CONTROL_PARAMETERS_FAIL,
    error,
  };
};

export const getMessageControlParameters = () => {
  return (dispatch: AppDispatch) => {
    return new Promise<MessageControlParameters>((resolve, reject) => {
      dispatch(getMessageControlParametersStart());

      const url = `/sms/get-message-control-parameters`;

      axios
        .get(url)
        .then((response) => {
          dispatch(getMessageControlParametersSuccess(response.data));
          resolve(response.data);
        })
        .catch((err) => {
          dispatch(getMessageControlParametersFail(err));
          reject(err);
        });
    });
  };
};

const getAllInsuredNumbersStart = () => {
  return {
    type: actionTypes.SMSES_GET_ALL_INSURED_NUMBERS_START,
  };
};

const getAllInsuredNumbersSuccess = (data: InsuredPhoneNumbersCollection) => {
  return {
    type: actionTypes.SMSES_GET_ALL_INSURED_NUMBERS_SUCCESS,
    data,
  };
};

const getAllInsuredNumbersFail = (error: any) => {
  return {
    type: actionTypes.SMSES_GET_ALL_INSURED_NUMBERS_FAIL,
    error,
  };
};

export const getAllInsuredNumbers = (params: GetAllInsuredNumbersRequest) => {
  return (dispatch: AppDispatch) => {
    return new Promise<InsuredPhoneNumbersCollection>((resolve, reject) => {
      dispatch(getAllInsuredNumbersStart());

      const url = `/sms/get-all-insured-numbers`;

      axios
        .post(url, params)
        .then((response) => {
          dispatch(getAllInsuredNumbersSuccess(response.data));
          resolve(response.data);
        })
        .catch((err) => {
          dispatch(getAllInsuredNumbersFail(err));
          reject(err);
        });
    });
  };
};

const getUpdatesStart = () => {
  return {
    type: actionTypes.SMSES_GET_UPDATES_START,
  };
};

export const getUpdatesSuccess = (data: GetUpdatesResult) => {
  return {
    type: actionTypes.SMSES_GET_UPDATES_SUCCESS,
    data,
  };
};

const getUpdatesFail = (error: any) => {
  return {
    type: actionTypes.SMSES_GET_UPDATES_FAIL,
    error,
  };
};

export const getUpdates = (params: SmsGetUpdatesRequest) => {
  return (dispatch: AppDispatch) => {
    return new Promise<GetUpdatesResult>((resolve, reject) => {
      dispatch(getUpdatesStart());

      const url = `/sms/get-updates`;

      axios
        .get(url, { params })
        .then((response) => {
          dispatch(getUpdatesSuccess(response.data));
          resolve(response.data);
        })
        .catch((err) => {
          dispatch(getUpdatesFail(err));
          reject(err);
        });
    });
  };
};

export const setLocalMessages = (data: MessagesCollection | null) => {
  return {
    type: actionTypes.SMSES_SET_LOCAL_MESSAGES,
    data,
  };
};

const sendMassMessagesStart = () => {
  return {
    type: actionTypes.SMSES_SEND_MASS_MESSAGES_START,
  };
};

const sendMassMessagesSuccess = (data: boolean) => {
  return {
    type: actionTypes.SMSES_SEND_MASS_MESSAGES_SUCCESS,
    data,
  };
};

const sendMassMessagesFail = (error: any) => {
  return {
    type: actionTypes.SMSES_SEND_MASS_MESSAGES_FAIL,
    error,
  };
};

export const sendMassMessages = (params: SendMassMessagesRequest) => {
  return (dispatch: AppDispatch) => {
    return new Promise<boolean>((resolve, reject) => {
      dispatch(sendMassMessagesStart());

      const url = `/sms/send-mass-messages`;

      axios
        .post(url, params)
        .then((response) => {
          dispatch(sendMassMessagesSuccess(response.data));
          resolve(response.data);
        })
        .catch((err) => {
          dispatch(sendMassMessagesFail(err));
          reject(err);
        });
    });
  };
};

export const setUpdates = (data: GetUpdatesResult) => {
  return {
    type: actionTypes.SMSES_SET_UPDATES,
    data,
  };
};

const checkPhoneNumberStart = () => {
  return {
    type: actionTypes.SMSES_CHECK_PHONE_NUMBER_START,
  };
};

const checkPhoneNumberSuccess = (data: CheckPhoneNumberResult) => {
  return {
    type: actionTypes.SMSES_CHECK_PHONE_NUMBER_SUCCESS,
    data,
  };
};

const checkPhoneNumberFail = (error: any) => {
  return {
    type: actionTypes.SMSES_CHECK_PHONE_NUMBER_FAIL,
    error,
  };
};

export const checkPhoneNumber = (params: CheckPhoneNumberRequest) => {
  return (dispatch: AppDispatch) => {
    return new Promise<CheckPhoneNumberResult>((resolve, reject) => {
      dispatch(checkPhoneNumberStart());

      const url = `/sms/check-phone-number`;

      axios
        .post(url, params)
        .then((response) => {
          dispatch(checkPhoneNumberSuccess(response.data));
          resolve(response.data);
        })
        .catch((err) => {
          dispatch(checkPhoneNumberFail(err));
          reject(err);
        });
    });
  };
};

export const setMessageControlParameters = (data: MessageControlParameters) => {
  return {
    type: actionTypes.SMSES_SET_MESSAGE_CONTROL_PARAMETERS_SUCCESS,
    data,
  };
};

const startMigrationStart = () => {
  return {
    type: actionTypes.SMSES_START_MIGRATION_START,
  };
};

const startMigrationSuccess = (data: SmsMigrationData) => {
  return {
    type: actionTypes.SMSES_START_MIGRATION_SUCCESS,
    data,
  };
};

const startMigrationFail = (error: any) => {
  return {
    type: actionTypes.SMSES_START_MIGRATION_FAIL,
    error,
  };
};

export const startMigration = () => {
  return (dispatch: AppDispatch) => {
    return new Promise<SmsMigrationData>((resolve, reject) => {
      dispatch(startMigrationStart());

      const url = `/sms/start-migration`;

      axios
        .get(url)
        .then((response) => {
          dispatch(startMigrationSuccess(response.data));
          resolve(response.data);
        })
        .catch((err) => {
          dispatch(startMigrationFail(err));
          reject(err);
        });
    });
  };
};

const saveMigrationStart = () => {
  return {
    type: actionTypes.SMSES_SAVE_MIGRATION_START,
  };
};

const saveMigrationSuccess = (data: boolean) => {
  return {
    type: actionTypes.SMSES_SAVE_MIGRATION_SUCCESS,
    data,
  };
};

const saveMigrationFail = (error: any) => {
  return {
    type: actionTypes.SMSES_SAVE_MIGRATION_FAIL,
    error,
  };
};

export const saveMigration = (params: SaveMigrationRequest) => {
  return (dispatch: AppDispatch) => {
    return new Promise<boolean>((resolve, reject) => {
      dispatch(saveMigrationStart());

      const url = `/sms/save-migration`;

      axios
        .post(url, params)
        .then((response) => {
          dispatch(saveMigrationSuccess(response.data));
          resolve(response.data);
        })
        .catch((err) => {
          dispatch(saveMigrationFail(err));
          reject(err);
        });
    });
  };
};

export const setSelectedChatItem = (data: SmsChat | undefined) => {
  return {
    type: actionTypes.SMSES_SET_SELECTED_CHAT_ITEM,
    data,
  };
};

export const clearMessageToInform = () => ({
  type: actionTypes.SMSES_CLEAR_MESSAGE_TO_INFORM,
});

export const clearMessageControlError = () => ({
  type: actionTypes.SMSES_CLEAR_MESSAGE_CONTROL_ERROR,
});
